import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';
import { round } from 'lodash';
import moment from 'moment';

export class TimeInTeamStatus extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static attributesForModel() {
    return ['durationInTeamWorkflowStatus'];
  }

  static subqueriesForModel() {
    return { teamWorkflowStatus: ['internalMeaning'] };
  }

  get title() {
    return 'Time in status';
  }

  exampleContents(): FieldContentsData {
    return {
      pill: {
        text: `3d`,
        color: '#e1e1e1',
        icon: { name: 'fa-regular fa-stopwatch' },
      },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (!record.teamWorkflowStatus) return {};
    if (!record.teamWorkflowStatus.isInProgress) return {};

    const inDays = round(
      moment
        .duration(record.durationInTeamWorkflowStatus || 0, 'seconds')
        .asDays(),
      0
    );

    return {
      pill: {
        text: `${inDays}d`,
        color: '#e1e1e1',
        icon: { name: 'fa-regular fa-stopwatch' },
      },
    };
  }
}
